<template>
  <!-- 实训目标文件列表 -->
  <div class="training-file-list">
    <div class="picture-box">
      <ul class="pictures">
        <li class="no-data" v-if="Pictures.records && Pictures.records.length === 0">
          <img :src="emptyImgUrl" alt="">
          <span>{{teacherOrStudentState ? '当前无数据，开始上传吧~' : '当前无数据'}}</span>
        </li>
        <li
          class="picture-item"
          v-for="(item, idx) in Pictures.records"
          :key="idx"
        >
          <i :class="[
            'preview-icon', modelType==1 || modelType==2 ? 
            'icon-see-img': (modelType==3 || modelType==4 ? 
            'el-icon-full-screen':'icon-caret-preview')]"
            @click="onFilePreview(item.fileUrl)"
            title="预览"
          ></i>
          <figure>
            <img class="img" v-if="modelType == 1 || modelType == 2" :src="photoBaseUrl + item.fileUrl" alt="" />
            <img class="img-top" v-if="modelType == 3 || modelType == 4" src="@/assets/images/txtImage@2x.png" alt="" />
            <img class="img-top" v-if="modelType == 5 || modelType == 6" src="@/assets/images/audioImage@2x.png" alt="" />
          </figure>
          <div class="btns" v-if="teacherOrStudentState ? (releaseStatus || modelLimitButtonShow ? false : true) : false">
            <button class="btn-delete" @click="activeDeletePopup(item.fileId, idx)">删除</button>
            <button class="btn-primary" @click="activeRenamePopup(item, idx)">重命名</button>
          </div>
          <div class="title ellipsis" :title="item.fileName">
            {{ item.fileName }}
          </div>
        </li>
      </ul>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="20"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="Pictures.total"
          :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 删除 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'batch_delete' || popupActive === 'all_delete'
            ? 'on' : 'off',
        ]"
        :title="`删除${modelTypeCompany(modelType)}`"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteOperate"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'batch_delete'" class="title">
                {{`确定批量删除所选${modelTypeCompany(modelType)}吗？`}}
              </span>
              <span v-show="popupActive === 'all_delete'" class="title">
                {{`确定删除数据集全部${modelTypeCompany(modelType)}吗？`}}
              </span>
              <span v-show="popupActive === 'delete'" class="title">
                {{`确定删除此${modelTypeCompany(modelType)}吗？`}}
              </span>
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 重命名 -->
      <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input placeholder="请输入重命名" v-model.trim="popupData.rename.fileName" maxlength="20" show-word-limit />
        </template>
      </gat-popup>

      <!--文件预览-->
      <file-preview
        :modelType="modelType"
        :fileUrl="fileUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
    </div>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js' // 项目标注接口

import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
import FilePreview from '@/components/pretrain/FilePreview.vue'

export default {
  name: "TrainingFileList",
  components: { GatPopup, IconInfoHelp, ModelTrainingUploadTips, FilePreview },
  props: {
    PicturesData: {
      type: Array,
      default: []
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    modelType: {
      type: String,
      default: '1'
    },
    modelLimitButtonShow: {
      type: Boolean,
      default: false
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC文件基地址
      fileUrl: '',
      popupActive: '',
      currentPage: 1, // 分页器当前页面
      Pictures: {
        records: [], // 文件列表
        size: 20,
        current: 1,
        total: 0,
      },
      imgPreviewUrl: '',
      dialogvisibleview: false,
      // 翻页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
        pagerCount: 5,
      },
      popupData: {
        rename: {
          index: -1,
          fileId: '',
          fileName: '',
        },
        uploadNoTip: false,
        delete: {
          index: -1,
        },
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      emptyImgUrl: require('../../../../assets/images/datasetLobby/icon-empty-box.png'),
      formdata: new FormData(),
      clickFlag: false,
      modFileNumAll: 0,
    }
  },
  computed: {
  },
  watch: {
    PicturesData: {
      handler(val) {
        this.Pictures.records = val
      },
      deep: true,
      immediate: true,
    },
    Pictures(val) {
      this.currentPage = val.current || 1;
    },
  },
  created() {},
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },

    // 预览图片
    onFilePreview(imgUrl) {
      this.fileUrl = this.photoBaseUrl + imgUrl;
      this.dialogvisibleview = true;
    },
    // 删除
    activeDeletePopup(fileId, index) {
      this.popupActive = 'delete';
      this.popupData.delete.index = index;
    },
    // 删除操作
    deleteOperate() {
      // 单删
      if (this.popupActive === 'delete') {
        let deleteIndex = this.popupData.delete.index,
          file = this.Pictures.records[deleteIndex],
          data = {
            editorType: this.modelType, // 类型
            fileId: file.fileId, // 文件id
            fileName: file.fileName, // 文件名称
          };
  
        MARKCENTER.deleteTrainingTargetFile(data).then((result) => {
          if (result.isSuccess) {
            // 关闭弹窗
            this.cancelPopup();
            this.$message.success(`已删除${this.modelTypeCompany(this.modelType)}：` + file.fileName);
            this.$emit('getTargetFile', this.Pictures.current);
          } else {
            this.$message.error(result.returnMsg);
          }
        })
      }
    },

    // 图片重命名
    activeRenamePopup(obj, index) {
      this.popupActive = 'rename';
      this.popupData.rename.index = index;
      this.popupData.rename.fileId = obj.fileId;
      this.popupData.rename.fileName = obj.fileName;

    },
    // 确认重命名
    renameOperate() {
      if (!this.popupData.rename.fileName) {
        return this.$message.error('重命名不能为空');
      }
      if (this.popupData.rename.fileName.length > 20) {
        return this.$message.error('重命名不能超过20个字符');
      }

      let renameIndex = this.popupData.rename.index,
        fileId = this.popupData.rename.fileId,
        fileName = this.popupData.rename.fileName,
        data = {
          editorType: this.modelType, // 类型
          fileId: fileId, // 文件id
          fileName: fileName // 文件名称
        },
        list = [];

      MARKCENTER.updateTrainingTargetFile(data).then((result) => {
        if (result.isSuccess) {
          list = JSON.parse(JSON.stringify(this.Pictures.records));
          list[renameIndex].fileName = fileName;
          this.Pictures.records = list;
          this.cancelPopup(); // 关闭弹窗
          this.$message.success(result.returnMsg);
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },

    //  取消弹窗
    cancelPopup() {
      this.popupActive = "";
    },
    // 图片翻页
    handleCurrentChange(current) {
      this.$emit('getTargetFile', current);
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
::v-deep.el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4C88FF;
  border-color: #4C88FF;
}
.training-file-list {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  // box-shadow: 0px 2px 6px 0px rgba(210,216,230,0.6);

  .picture-box {
    min-height: 560px;
    // height: 100%;
    background-color: #fff;
    position: relative;
    padding: 20px 0 80px;
    .pictures {
      display: flex;
      flex-wrap: wrap;
      .no-data {
        color: rgb(145, 144, 144);
        width: 300px;
        height: 160px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 134px;
          height: 80px;
        }
        span {
          color: #BDC3D2;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          margin-top: 16px;
        }
      }
      .picture-item {
        overflow: hidden;
        position: relative;
        width: 18%;
        margin: 0 1%;
        .preview-icon {
          font-weight: 700;
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1;
          cursor: pointer;
        }
        .el-icon-full-screen {
          color: #676767;
        }
        .icon-see-img,
        .icon-caret-preview {
          width: 17px;
          height: 17px;
          background: url("../../../../assets/images/datasetLobby/icon-see-img.png") no-repeat;
          background-size: 100% 100%;
        }
        .icon-caret-preview {
          background: url("../../../../../public/images/icon-play.png") no-repeat;
          background-size: 100% 100%;
        }
        figure {
          overflow: hidden;
          width: 100%;
          height: 140px;
          padding: 0;
          margin: 0;
          text-align: center;
          background-color: #e4e8f2;
          &:hover + .btns {
            visibility: visible;
            opacity: 1;
          }
          img {
            height: 100%;
            display: inline-block;
          }
          .img-top {
            height: 120px;
            padding-top: 10px;
          }
        }
        // .imageSizeText {
        //   color: #ccc;
        //   position: absolute;
        //   left: 8px;
        //   bottom: 55px;
        //   display: flex;
        //   span:last-child {
        //     margin-left: 10px;
        //   }
        // }
        .checkbox {
          position: absolute;
          left: 8px;
          bottom: 55px;
        }
        .btns {
          visibility: hidden;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          box-sizing: border-box;
          // width: 80px;
          height: 140px;
          padding: 28px 72.5px 0;
          margin: 0 auto;
          background-color: rgba(8, 16, 44, 0.7);
          opacity: 0;
          @include transition;
          button {
            width: 80px;
            height: 36px;
            padding: 0;
            border: 0 none;
            outline: 0 none;
            border-radius: 3px;
            margin-bottom: 15px;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
          }
          .btn-delete {
            background-color: $bgc_btn_del_1;
            &:hover {
              background: $bgc_btn_del_1_hover;
            }
            &:active {
              background-color: $bgc_btn_del_1;
            }
          }
          .btn-primary {
            color: $font_white;
            background-color: #4c88ff;
          }
          &:hover {
            visibility: visible;
            opacity: 1;
          }
        }
        .title {
          margin: 0 1.5em 10px;
          text-align: center;
          line-height: 40px;
        }
      }
    }

    .pagination {
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 20px 0;
    }
  }
  
  // 弹窗
  .popup-list {
    .popup-delete,
    .popup-rename,
    .popup-upload-tip {
      &.off {
        display: none;
      }
    }
    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
        }
      }
    }

    .popup-delete-2 {
      &::v-deep .popup-inner {
        width: 420px;
        height: 200px;
      }
      .popup-del-cnt {
        margin-top: 10px;
        .head {
          text-align: center;
         }
      }
    }
  }
}
</style>
